import React from 'react';
import Select from 'react-select';

const panelSelectStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: '#f3f4f6',
    borderColor: '#d1d5db',
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const portalProps = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  menuPosition: "absolute",
};

function AppointmentFilterPanel({
  dataForm,
  updateFilters,
  specialitiesList,
  selectedSpecialities,
  handleSpecialityChange,
  citiesList,
  selectedCity,
  handleCityChange,
}) {
  const availability = dataForm.availability || [];

  // Checking a gender selects it; checking it again clears the filter
  const handleGenderChange = (value) => {
    updateFilters({ gender: dataForm.gender === value ? "" : value });
  };

  const handleAvailabilityChange = (value, checked) => {
    updateFilters({
      availability: checked
        ? [...availability, value]
        : availability.filter((v) => v !== value),
    });
  };

  const checkbox = (id, label, checked, onChange) => (
    <div className="flex items-center mb-2">
      <input
        className="form-checkbox h-4 w-4 text-blue-600 cursor-pointer"
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      <label className="ml-2 text-gray-700 cursor-pointer" htmlFor={id}>{label}</label>
    </div>
  );

  return (
    <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg w-full">
      {/* Specialty Filter */}
      <div className="mb-4">
        <label className="block text-gray-700 font-medium mb-2" htmlFor="filter-specialty">Specialty</label>
        <Select
          inputId="filter-specialty"
          name="specialite"
          isMulti
          options={specialitiesList}
          value={selectedSpecialities}
          onChange={handleSpecialityChange}
          placeholder="All Specialties"
          className="react-select-container"
          classNamePrefix="react-select"
          styles={panelSelectStyles}
          {...portalProps}
        />
      </div>

      {/* City Filter */}
      <div className="mb-4">
        <label className="block text-gray-700 font-medium mb-2" htmlFor="filter-city">City</label>
        <Select
          inputId="filter-city"
          name="city_id"
          options={citiesList}
          value={selectedCity}
          onChange={handleCityChange}
          placeholder="All Cities"
          isClearable
          className="react-select-container"
          classNamePrefix="react-select"
          styles={panelSelectStyles}
          {...portalProps}
        />
      </div>

      {/* Gender Filter */}
      <div className="mb-4">
        <p className="block text-gray-700 font-medium mb-2">Gender</p>
        {checkbox("gender-female", "Female", dataForm.gender === "female", () => handleGenderChange("female"))}
        {checkbox("gender-male", "Male", dataForm.gender === "male", () => handleGenderChange("male"))}
      </div>

      {/* Availability Filter */}
      <div className="mb-4">
        <p className="block text-gray-700 font-medium mb-2">Availability</p>
        {checkbox("available-today", "Available Today", availability.includes("today"),
          (e) => handleAvailabilityChange("today", e.target.checked))}
        {checkbox("available-tomorrow", "Available Tomorrow", availability.includes("tomorrow"),
          (e) => handleAvailabilityChange("tomorrow", e.target.checked))}
      </div>
    </div>
  );
}

export default AppointmentFilterPanel;
